import { client } from '@/client';

// 获取流程列表
export function queryFlowList(params) {
  return client.post('/api/exe_flow_service/page-query', params);
}

// 获取流程步骤
export function getFlowSteps(params) {
  return client.post('/api/exe_flow_service/step', params);
}

// 获取流程所有参数
export function getFlowInitVariables(params) {
  return client.post('/api/exe_flow_service/variable/init', params);
}

// 获取流程高级选项
export function getFlowAdvanced(params) {
  return client.post('/api/exe_flow_service/advanced/options', params);
}

// 执行
export function runFlow(params) {
  return client.post('/api/exe_flow_service/run', params);
}

// // 获取默认快速发布流程
// export function getDeployFlowInfo() {
//   return client.get('/api/flow_stencil_base_info/default');
// }
